export default "__VITE_ASSET__DThyGRbY__"